import type { QuoteVariant } from "../Quote";
import gwenPortrait from "@themes/pollinator/assets/images/portrait-gwen-smith.png";
import shanaPortrait from "@themes/pollinator/assets/images/portrait-shana-kaplow.png";
import marioPortrait from "@themes/pollinator/assets/images/portrait-mario-andres-rodriguez.png";
import ofemPortrait from "@themes/pollinator/assets/images/portrait-ofem-ubi.png";

export type MarketingQuoteItem = {
  /** Punctuated as the design punctuates it, which is not uniform */
  quote: React.ReactNode;
  attribution?: string;
  variant: QuoteVariant;
  portraitUrl?: string;
  /** The design's column width for this band's words */
  copyWidthClassName?: string;
};

/**
 * The quotes on the homepage, transcribed from the design with its hidden
 * layers ignored: Claire has no portrait, because the design hides it.
 */
export const marketingQuotesData: MarketingQuoteItem[] = [
  {
    quote:
      "“Relationships are how we find jobs, collaborators, and funding. Networks are how relationships compound, and how we move together.”",
    attribution: "Claire Wathen, Pollinator Advisor and Fellow at Oxford University",
    variant: "centered",
  },
  {
    quote:
      "“The gift Pollinator gave me was the clarity that I am an artist who constructs narratives where culture coincides with the elevation of Blackness. I no longer need the restrictive curse of labels like ‘interdisciplinary’ or ‘multidisciplinary’ to describe my process.”",
    attribution: "Gwen Smith, Pollinator Participant",
    variant: "band",
    portraitUrl: gwenPortrait,
  },
  {
    quote:
      "“One of many magical things that happened in our very first meeting was that after sharing briefly about my art practice, the other members offered their reflections and went really deep into nuanced aspects of my work that I hadn’t even talked about. This was an affirming gift. I didn’t expect that level of understanding, connection, and support to happen so quickly.”",
    attribution: "Shana Kaplow, Pollinator Participant",
    variant: "band",
    portraitUrl: shanaPortrait,
  },
  {
    quote:
      "“[The Pollinator meeting] reminded me of the value of community, connection, and how people can walk so many different paths in cultural fields while still finding lines of connection.”",
    attribution: "Mario Andrés Rodríguez, Pollinator Participant",
    variant: "band",
    copyWidthClassName: "lg:max-w-[847px]",
    portraitUrl: marioPortrait,
  },
  {
    quote:
      "“Every week brought us closer; we got to learn something new about ourselves, our processes and what goals we were chasing.”",
    attribution: "Ofem Ubi, Pollinator Participant",
    variant: "band",
    copyWidthClassName: "lg:max-w-[600px]",
    portraitUrl: ofemPortrait,
  },
];
